import { render, staticRenderFns } from "./company-info-auth.vue?vue&type=template&id=01a2d3ef&scoped=true&"
import script from "./company-info-auth.vue?vue&type=script&lang=js&"
export * from "./company-info-auth.vue?vue&type=script&lang=js&"
import style0 from "./company-info-auth.vue?vue&type=style&index=0&id=01a2d3ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2d3ef",
  null
  
)

export default component.exports